import { ListObjectsCommand, S3Client } from "@aws-sdk/client-s3";
import { EuiButton } from "@elastic/eui";
import React, { useState } from "react";

import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, REGION, S3_BUCKET } from "../Constants";
import ProductImage from "./ProductImage";

const s3Client = new S3Client({
    region: REGION,
    credentials: {
        accessKeyId: AWS_ACCESS_KEY_ID,
        secretAccessKey: AWS_SECRET_ACCESS_KEY,
    },
});

const ListS3Images = () => {
    const [images, setImages] = useState([]);

    const retrieve = async () => {
        try {
            const data = await s3Client.send(new ListObjectsCommand({ Bucket: S3_BUCKET, Delimiter: "/" }));
            const keys = (data.Contents || []).map((item) => item.Key);
            console.log(keys);
            setImages(keys);
        } catch (err) {
            alert("There was an error listing your albums: " + err.message);
        }
    };

    console.log(images);

    return (
        <div>
            <EuiButton size="s" iconType="refresh" onClick={retrieve}>
                {" "}
                Retrieve list
            </EuiButton>
            <div>
                {images.map((item) => (
                    <ProductImage imageKey={item} />
                ))}
            </div>
        </div>
    );
};

export default ListS3Images;
